import React from "react";
import Input from '@mui/material/Input';
import GenericInput from "./GenericInput";

class UsernameInput extends GenericInput {
  
  renderInputElement(): React.ReactNode {
    return (
      <Input
        id={this.inputId}
        type="text"
        autoFocus={this.props.autoFocus}
        value={this.props.value}
        name="username"
        onChange={this.handleChangeEvent}
        onKeyDown={this.props.onKeyDown}
        onFocus={this.handleFocusEvent}
        onBlur={this.handleBlurEvent}
        disabled={this.props.disabled || this.props.loading}
        endAdornment={this.renderRightElement()}
        startAdornment={this.renderLeftElement()}
      />
    );
  }

}

export default UsernameInput;